/** «پیشنهاد / گزارش مشکل» from the partner panel: kinds, statuses and their labels. */

export type FeedbackKindKey = 'suggestion' | 'problem';
export type FeedbackStatusKey = 'new' | 'seen' | 'done';

export const FEEDBACK_KIND_LABELS: Record<FeedbackKindKey, string> = { suggestion: 'پیشنهاد', problem: 'گزارش مشکل' };
export const FEEDBACK_STATUS_LABELS: Record<FeedbackStatusKey, string> = { new: 'تازه', seen: 'دیده شد', done: 'پاسخ داده شد' };

/** Message length bounds, the same in the panel and the API. */
export const FEEDBACK_MIN_CHARS = 10;
export const FEEDBACK_MAX_CHARS = 2000;
